import React from 'react';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { RadioGroup, RadioGroupItem } from '../../components/ui/radio-group';

// Compact Yes/No/Not-sure question.
const TriQuestion = ({ id, question, value, onChange, errEl, includeNotSure = true, customYesLabel, customNoLabel, tr }) => {
  const yesLabel = customYesLabel || tr('wizard.common.yes');
  const noLabel = customNoLabel || tr('wizard.common.no');
  const notSureLabel = tr('wizard.common.notSure') || (tr('wizard.common.no') === 'No' ? 'Not sure' : 'No estoy seguro');
  return (
    <div>
      <Label className="text-base font-semibold mb-3 block">{question}</Label>
      <RadioGroup value={value || ''} onValueChange={onChange} className="space-y-2">
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="yes" id={`${id}-yes`} data-testid={`${id}-yes`} />
          <Label htmlFor={`${id}-yes`} className="cursor-pointer font-normal">{yesLabel}</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="no" id={`${id}-no`} data-testid={`${id}-no`} />
          <Label htmlFor={`${id}-no`} className="cursor-pointer font-normal">{noLabel}</Label>
        </div>
        {includeNotSure && (
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="not-sure" id={`${id}-not-sure`} data-testid={`${id}-not-sure`} />
            <Label htmlFor={`${id}-not-sure`} className="cursor-pointer font-normal">{notSureLabel}</Label>
          </div>
        )}
      </RadioGroup>
      {errEl}
    </div>
  );
};

export const Step1ProjectDetails = ({ formData, updateFormData, errFor, tr }) => {
  return (
    <div className="space-y-7">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-1">
          {tr('wizard.simplified.step2.title')}
        </h2>
        <p className="text-gray-600">{tr('wizard.simplified.step2.subtitle')}</p>
      </div>

      {/* Business description */}
      <div>
        <Label htmlFor="whatBuilding" className="text-base font-semibold mb-2 block">
          {tr('wizard.simplified.step2.whatBuilding')}
        </Label>
        <Textarea
          id="whatBuilding"
          value={formData.whatBuilding}
          onChange={(e) => updateFormData('whatBuilding', e.target.value)}
          placeholder={tr('wizard.simplified.step2.whatBuildingPlaceholder')}
          className="min-h-24"
          data-testid="whatBuilding-input"
        />
        {errFor('whatBuilding')}
      </div>

      {/* Mexican address */}
      <TriQuestion
        id="hasAddress"
        question={tr('wizard.simplified.step2.hasAddress')}
        value={formData.hasAddress}
        onChange={(v) => updateFormData('hasAddress', v)}
        errEl={errFor('hasAddress')}
        includeNotSure={false}
        customYesLabel={tr('wizard.common.yes')}
        customNoLabel={tr('wizard.simplified.step2.hasAddressNo')}
        tr={tr}
      />

      <TriQuestion
        id="rfcNeeded"
        question={tr('wizard.simplified.step2.rfcNeeded')}
        value={formData.rfcNeeded}
        onChange={(v) => updateFormData('rfcNeeded', v)}
        errEl={errFor('rfcNeeded')}
        tr={tr}
      />

      <TriQuestion
        id="bankAccountNeeded"
        question={tr('wizard.simplified.step2.bankAccountNeeded')}
        value={formData.bankAccountNeeded}
        onChange={(v) => updateFormData('bankAccountNeeded', v)}
        errEl={errFor('bankAccountNeeded')}
        tr={tr}
      />

      <TriQuestion
        id="governanceNeeded"
        question={tr('wizard.simplified.step2.governanceNeeded')}
        value={formData.governanceNeeded}
        onChange={(v) => updateFormData('governanceNeeded', v)}
        errEl={errFor('governanceNeeded')}
        tr={tr}
      />

      <TriQuestion
        id="landRestrictedZone"
        question={tr('wizard.simplified.step2.landRestrictedZone')}
        value={formData.landRestrictedZone}
        onChange={(v) => updateFormData('landRestrictedZone', v)}
        errEl={errFor('landRestrictedZone')}
        tr={tr}
      />

      {/* Optional taxIDs textarea */}
      <div>
        <Label htmlFor="taxIDs" className="text-base font-semibold mb-2 block">
          {tr('wizard.simplified.step2.taxIDs')}
        </Label>
        <p className="text-sm text-gray-500 mb-2">{tr('wizard.simplified.step2.taxIDsHelp')}</p>
        <Textarea
          id="taxIDs"
          value={formData.taxIDs || ''}
          onChange={(e) => updateFormData('taxIDs', e.target.value)}
          placeholder={tr('wizard.simplified.step2.taxIDsPlaceholder')}
          className="min-h-20"
          data-testid="taxIDs-input"
        />
      </div>
    </div>
  );
};
